import React, { useState } from 'react';

import selectedresume from '../../assets/selected-resume.png';
import Sidebar from '../../common/sidebar'
import {
    BrowserRouter as Router, Switch, Route, Link , useHistory
  } from "react-router-dom";


const MyResume = ({ toggle }) => {
    const [collapse, setCollapse] = useState(false);
    const togglecollapse = () => setCollapse(!collapse);
    
    return (
      <div className="row pd-l-5">
      <Sidebar />
      <div className="page-wrapper wd-pct-100" style={{marginLeft:'255px'}}>
        <div className="card">
          <div className="resume-bar v-align">
            <div className="v-align col-md-5 pd-r-15">
              <div className="resume-bar-header">Name</div>
              <input type="text" className="form-control" placeholder="max 20 characters" ></input>
            </div>
            
            <div style={{marginLeft:'auto'}}>
              <button className="btn btn-primary mg-r-10">Generate</button>
              <button className="btn btn-primary mg-r-10">Save</button>
              <button className="btn btn-primary">Download</button>
            </div>
          </div>
        </div>
        <div className="pd-t-15">
        
          <div className="v-align ">
          
            <div ><i className="fas fa-angle-double-left pd-r-15 resume-icon"></i></div>
            <div ><i className="fas fa-angle-left pd-r-30 resume-icon"></i></div>
            <div >Showing 1 of 5</div>
            <div ><i className="fas fa-angle-right pd-l-30 resume-icon"></i></div>
            <div ><i className="fas fa-angle-double-right pd-l-15 resume-icon"></i></div>
          
         </div>
          <div className="col-md-12 text-center">
            <img src={selectedresume} style={{height: '660px'}} className="b-border" />
          </div>
        </div>
      </div>
      
      
      </div>
)}
export default MyResume;